import { DateTime } from 'luxon';

export const getAppointmentCta = (scheduledDate: string, visitType = '') => {
	const convertedDate = DateTime.fromISO(scheduledDate);
	const convertedHours = convertedDate?.diffNow('hours').hours;
	const isWithinRescheduleWindow = convertedHours >= 3;
	const isWithinCancelWindow = convertedHours < 3 && convertedHours > 1;
	const isWithinAppointmentWindow = Math.abs(convertedHours) <= 1;

	if (isWithinRescheduleWindow) {
		return 'Reschedule / Cancel';
	}
	if (isWithinCancelWindow) {
		return 'Cancel';
	}
	if (isWithinAppointmentWindow) {
		return visitType === 'irl' ? undefined : 'Join Visit';
	}

	return undefined;
};
